<template lang="pug">
a.channel-list-item
  .card
    .card-image(@click="click(channel)")
      figure.image.is-16by9
        img(:src="image")
    .card-content
      b(@click="click(channel)") {{ channel.title }}
      .level
        .level-left
          .level-item
            small {{ channel.episode_count }} {{ label }}
          .level-item
            small
              a(:href="iTunesLink" target="_blank") iTunes Link
</template>

<script>
import { mapGetters } from 'vuex';
import cloudinary from 'cloudinary-core';
import * as getters from '@/store/types/getters';

export default {
  name: 'channel-list-item',
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
    }),
    image() {
      if (this.channel._embedded && this.channel._embedded.artwork) {
        const id = this.channel._embedded.artwork.cl_id;
        return this.cloudinary.url(id, this.props);
      }
      return null;
    },
    iTunesLink() {
      return `${process.env.API_ENDPOINT}/feeds/${this.channel.key}`;
    },
    label() {
      return this.channel.episode_count === 1 ? 'episode' : 'episodes';
    },
  },
  created() {
    this.cloudinary = cloudinary.Cloudinary.new({
      cloud_name: process.env.CLOUDINARY_CLOUD_NAME,
    });
  },
  data() {
    return {
      cloudinary: null,
      props: {
        quality: 'auto',
        fetch_format: 'auto',
        // crop: 'thumb',
        // aspect_ratio: 1,
        // width: 600,
        // height: 600,
      },
    };
  },
  methods: {
    click() {
      this.$emit('click', this.channel);
    },
  },
  props: {
    channel: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.channel-list-item {
  &:hover {
    .card {
      // box-shadow: 0 3px 16px rgba(0,0,0,0.1);
    }
  }
  .card {
    box-shadow: none;
    transition: box-shadow 0.35s ease-in-out;
    border-radius: 4px;
    .card-image {
      .image {
        img {
          border-radius: 4px 4px 0 0;
        }
      }
    }
    .card-content {
      border: 1px solid #dbdbdb;
      border-top: none;
      border-radius: 0 0 4px 4px;
      small {
        display: block;
        color: #868686;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChannelListItem.vue